import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageHero from './PageHero';

const Refund = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();

  return (
    <div className="refund-page">
      <PageHero title={t('refund_title')} />
      <div className="container" style={{ padding: '40px 0' }}>
        <section className="fade-up">
          <h2>{t('refund_overview_title')}</h2>
          <p>{t('refund_overview_body')}</p>
        </section>
        <section className="fade-up stagger-1">
          <h2>{t('refund_eligibility_title')}</h2>
          <p>{t('refund_eligibility_body')}</p>
        </section>
        <section className="fade-up stagger-2">
          <h2>{t('refund_request_title')}</h2>
          <p>{t('refund_request_body')}</p>
        </section>
        <section className="fade-up stagger-3">
          <h2>{t('refund_processing_title')}</h2>
          <p>{t('refund_processing_body')}</p>
        </section>
      </div>
    </div>
  );
};

export default Refund;
